import { api, type AuthUser, setApiToken, setStoredUser } from "./api";

export type CodeAvailability = {
  code: string;
  available: boolean;
  reason: string | null;
};

export type JoinPayload = {
  invite_code: string;
  email: string;
  first_name: string;
  last_name: string;
  phone?: string;
  // Optional — leer lassen, dann generiert das Backend vorname-nachname.
  agent_code?: string;
  accept_tos: boolean;
};

export type InviteInfo = {
  valid: boolean;
  agent_name: string | null;
};

export const getInviteInfo = (code: string) =>
  api.get<InviteInfo>(`/public/invite-info?code=${encodeURIComponent(code)}`);

export type JoinResponse = {
  token: string;
  user: AuthUser;
  plaintext_password: string;
  welcome_note: string;
};

export const checkPublicCode = (code: string) =>
  api.get<CodeAvailability>(`/public/check-code?code=${encodeURIComponent(code)}`);

export const generatePublicCode = (base?: string) =>
  api.get<{ code: string }>(
    `/public/generate-code${base ? `?base=${encodeURIComponent(base)}` : ""}`,
  );

export async function publicJoin(payload: JoinPayload): Promise<JoinResponse> {
  const res = await api.post<JoinResponse>("/public/join", payload);
  setApiToken(res.token);
  setStoredUser(res.user);
  return res;
}
